import { create } from "zustand";
import type { Dashboard } from "@/common/types/dashboard";
import { getDashboard } from "@/services/dashboard";

export interface DashboardState {
  loading: boolean;
  data: Dashboard;
  fetch: (userId: number) => Promise<void>;
}

export const useDashboardStore = create<DashboardState>()((set) => ({
  loading: false,
  error: null,
  data: {
    charts: {
      monthlyPlanUsed: {
        minutesUsed: 0,
        totalMinutes: 0,
      },
    },
  },
  fetch: async (userId: number): Promise<void> => {
    set({ loading: true });
    try {
      const data = await getDashboard(userId);
      set({ data, loading: false });
    } catch {
      // soft catch
    }
  },
}));
